// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__Zttrv","label":"Section_label__28bAl","contentWrap":"Section_contentWrap__k657Q","footer":"Section_footer__3Lcvl","footerInner":"Section_footerInner__26FSz"};